import EventActionProto from "../event-action-proto"
import {SESSION_STARRED_CHANGED} from "../../gd/bus/bus-event-type"
import StarredItemsCollection from "../../model2/starred/collection";

export default class StarredResetEvent extends EventActionProto {

    constructor(sessionEvent: any) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
    }

    process() {


        // gd.session.starredItems.reset(this.data)
        gd.session.starredItems = StarredItemsCollection.initFromJson(this.data)

        gd.bus.triggerEvent(SESSION_STARRED_CHANGED)
    }
}
